// extracted by mini-css-extract-plugin
export var numpadContainer = "_q1-1";
export var phoneButton = "_q1-0";